<template>
  <div class="table-wrapper">
    <div class="row">
      <div class="col-md-6 col-sm-12 grid-search-control">
        <SearchField
          v-model:textSearch="textSearch"
          placeholder="Search for assets by asset name, description or location name"
          @input="isSpinnerVisible = true"
          @search="search"
        />
      </div>
    </div>

    <div
      class="table-responsive"
      v-bind:class="{ 'spinner-is-visible': isSpinnerVisible }"
    >
      <table class="table">
        <thead>
          <tr>
            <SortableHeader
              style="width: 300px"
              :current-sort="orderBy"
              :sort-by="'NAME'"
              @sort="reorder"
            >Asset</SortableHeader>

            <SortableHeader
              style="width: 300px"
              :current-sort="orderBy"
              :sort-by="'SITE_NAME'"
              @sort="reorder"
            >Location</SortableHeader>

            <th>Details</th>

            <SortableHeader 
              class="text-center"
              style="width: 200px"
              :current-sort="orderBy"
              :sort-by="'CLIENT_REMEDIATED_RATING'"
              @sort="reorder"
            >Worst Case Damage</SortableHeader>

            <SortableHeader 
              class="text-end"
              style="width: 150px"
              :current-sort="orderBy"
              :sort-by="'APPROVED_ACTIVITY_DATE'"
              @sort="reorder"
            >Last Activity</SortableHeader>

            <th data-sorter="false" class="d-none d-md-table-cell"></th>
          </tr>
        </thead>

        <tbody>
          <PhysicalAsset
            v-bind="item" 
            v-for="(item, index) in items"
            :key="item.id"
            :index="index"
            :policy-update="policyUpdate"
            :ref="item.id"
            :selected="isItemMarked(item.id)"
          />
        </tbody>
      </table>

      <div class="spinner"></div>

      <NoRecords 
        label="According to the search criteria, there are no physical assets found."
      />

      <Pagination
        v-bind="pageInfo"
        entity-type="assets"
        @navigate-to="paginate"
      />
    </div>
  </div>
</template>

<script>
import Grid from "../shared/grid/grid";

import PhysicalAsset from "./physical_asset";

export default {
  extends: Grid,

  components: {
    PhysicalAsset
  },

  data: function () {
    return {
      items: [],

      grid: "physical-assets",

      textSearch: '',

      defaultOrderBy: {
        field: "SITE_NAME",
        direction: "ASC"
      },
      
      orderBy: {
        field: "SITE_NAME",
        direction: "ASC"
      },

      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        totalCount: 0,
        totalPageCount: 0
      },

      isSpinnerVisible: true
    }
  },

  computed: {
    filterParams: function () {
      if (this.textSearch) {
        return {
          text: {
            value: this.textSearch,
            fields: this.textSearchFields
          }
        };
      }
    },

    textSearchFields: function () {
      return ["NAME", "DESCRIPTION", "SITE_NAME"];
    }
  },

  methods: {
    fetch: function (params, success) {
      app.graphql.get("grid.assets",
        params,

        (data) => {
          let physical_assets = data.data.physicalAssets,
              pageInfo = physical_assets.pageInfo;

          success(physical_assets, pageInfo);
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch physical assets!"
          })
        }
      )
    }
  }
}
</script>
